import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface WaypointDirectionsDialogProps {
    open: boolean;
    toggleOpen: () => void;
    handleGeolocateAllow: () => void;
}

const EnableLocationServices: React.FC<WaypointDirectionsDialogProps> = ({
    open,
    toggleOpen,
    handleGeolocateAllow,
}) => {
    return (
        <Dialog
            open={open}
            onClose={toggleOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className="bg-plot-blue text-white" id="alert-dialog-title">
                Disclaimer
            </DialogTitle>
            <DialogContent className="mt-2 flex flex-col gap-4">
                <DialogContentText>
                    Location tracking allows us to provide you with accurate directions and will automatically stop when
                    you close this page or click stop sharing.
                </DialogContentText>
            </DialogContent>
            <DialogContent className="flex flex-col items-center justify-center gap-4">
                <DialogContentText sx={{ fontWeight: "bold" }}>Informational only. </DialogContentText>
                <DialogContentText sx={{ fontWeight: "bold" }}>Do not use while driving.</DialogContentText>
                <DialogContentText sx={{ fontWeight: "bold" }}>Follow all site instructions.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={toggleOpen}>Do Not Allow</Button>
                <Button onClick={handleGeolocateAllow} autoFocus>
                    Allow
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default EnableLocationServices;
